import axios from "axios"
import client, { BASE_URL } from "../services/api"
import CryptoJS from "crypto-js";
import { STORAGE_KEY } from "@/stores/user-store";

export const logoutAPI = async  () => {
    const response = await client.get('/auth/logout')

    return response.data
}

export const refreshToken = async () => {
    console.log('refreshToken: Attempting to refresh token.');
    const authString = localStorage.getItem(STORAGE_KEY);

    if (!authString) {
        console.error('refreshToken: No auth data in local storage.');
        return Promise.reject(new Error("No auth data found in local storage."));
    }

    const auth: { refresh_token: string, token: string } = JSON.parse(authString);

    if (!auth.refresh_token) {
        console.error('refreshToken: No refresh token found in auth data.');
        return Promise.reject(new Error("No refresh token found"));
    }
    console.log('refreshToken: Refresh token found.');

    let serverDifferent = Number(localStorage.getItem('serverTimeOffset') || 0)
    

    const secret_key = import.meta.env.VITE_SECRET_KEY
    const timestamp = Math.round(Date.now() / 1000) + serverDifferent 
    const data = JSON.stringify({timestamp: `${timestamp}`})
    const hash = CryptoJS.HmacSHA256(data, secret_key).toString()



    console.log('refreshToken: Sending refresh token request.');
    const response = await axios.get(`${BASE_URL}auth/refresh-token`, {
        headers: {
            'Authorization': `Bearer ${auth?.refresh_token}`,
            "X-Signature": `${timestamp}:${hash}`,
        }
    })

    console.log('refreshToken: Received response:', response.data);

    return response.data
}

export const authCheck = ()=> {
    return client.get('/auth/check')
}
